import {useSelector} from 'react-redux'

import {installFullStorySnippet} from '@vio/core/src/_web/utils/analytics/fullstorySnippet'
import {getFullStoryObject} from '@vio/core/src/analytics/utils/FullStory'
import {getIsGhaChecker} from '@vio/core/src/rateChecker/selectors'
import {logAndCaptureErrorMessage} from '@vio/core/src/utils/logging/errorHandlers'

/**
 * Installs FullStory during render, before any child mounts, so their events
 * are not dropped. GHA checkers are skipped, whichever signal identified them:
 * their recordings are of no use, and FullStory uploads run during the few
 * seconds a checker spends reading the price.
 */
export const useInstallFullStory = () => {
  const isGhaChecker = useSelector(getIsGhaChecker)

  if (typeof window === 'undefined' || isGhaChecker || getFullStoryObject()) {
    return
  }

  try {
    installFullStorySnippet()
  } catch (error) {
    logAndCaptureErrorMessage(error)
  }
}
